import PowerAppEmbed from "../../../pages/PowerApp";
import PowerBIReportEmbed from "../../../pages/PowerBIReportEmbed";
import SNO from "../../../pages/SNO_DOM";
import DemandSupplyPlanning from "../../../pages/demand-supply-planning/components";
import DeploymentOptimization from "../../../pages/DO_DP";
import Distribution_Planning from "../../../pages/distribution-planning";
import UserAccManagement from "../../../pages/userAccManagement";
import ModuleRunStatus from "../../../pages/mrs";
import FgSalvage from "../../../pages/FgSalvage";
import POOS from "../../../pages/POOS";
import CapacityPlanning from "../../../pages/CapacityPlanning";
import PowerBi_Viewer from "../../../pages/PowerBi_Viewer";
import F_Forecast from "../../../pages/F_Forecaste";
import Rapid_Response from "../../../pages/Rapid_Response";
import IF_Overall from "../../../pages/IF_Overall";
import Network_Planning from "../../../pages/network-planning";
import IOFPB from "../../../pages/IOF_PB";
import Business_Supply_Chain from "../../../pages/BSC";
import IOF_Prioritization from "../../../pages/IOF- Prioritization";
import Exception_Reason_Managment from "../../../pages/erm";
const routes = [
  {
    path: "/",
    component: <PowerBIReportEmbed />,
    exact: true,
    moduleName: "SNO",
  },
  {
    path: "/sno",
    component: <SNO />,
    exact: true,
    moduleName: "SNO",
  },
  {
    path: "/dom",
    component: <SNO />,
    exact: true,
    moduleName: "SNO",
  },
  {
    path: "/rr",
    component: <Rapid_Response />,
    exact: true,
    moduleName: "SNO",
  },
  {
    path: "/action/:path",
    component: <PowerAppEmbed />,
    exact: true,
    moduleName: "SNO",
  },
  {
    path: "/dsp",
    component: <DemandSupplyPlanning />,
    exact: true,
    moduleName: "SNO",
  },
  {
    path: "/do",
    component: <DeploymentOptimization />,
    exact: true,
    moduleName: "SNO",
  },
  {
    path: "/dp",
    component: <DeploymentOptimization />,
    exact: true,
    moduleName: "SNO",
  },
  {
    path: "/ua",
    component: <UserAccManagement />,
    exact: true,
    moduleName: "SNO",
  },
  {
    path: "/fgs",
    component: <FgSalvage />,
    exact: true,
    moduleName: "SNO",
  },
  {
    path: "/dip",
    component: <Distribution_Planning />,
    exact: true,
    moduleName: "SNO",
  },
  {
    path: "/cp",
    component: <CapacityPlanning />,
    exact: true,
    moduleName: "SNO",
  },
  {
    path: "/nps",
    component: <Network_Planning />,
    exact: true,
    moduleName: "SNO",
  },
  {
    path: "/mrs",
    component: <ModuleRunStatus />,
    exact: true,
    moduleName: "SNO",
  },
  {
    path: "/poos",
    component: <POOS />,
    exact: true,
    moduleName: "SNO",
  },
  // {
  //   path: "/ff",
  //   component: <F_Forecast />,
  //   exact: true,
  //   moduleName: "SNO",
  // },
  {
    path: "/tm",
    component: <F_Forecast />,
    exact: true,
    moduleName: "SNO",
  },
  {
    path: "/ds",
    component: <F_Forecast />,
    exact: true,
    moduleName: "SNO",
  },
  {
    path: "/if",
    component: <IF_Overall />,
    exact: true,
    moduleName: "SNO",
  },
  {
    path: "/iofpb",
    component: <IOFPB />,
    exact: true,
    moduleName: "SNO",
  },
  {
    path: "/slp",
    component: <Business_Supply_Chain />,
    exact: true,
    moduleName: "SNO",
  },
  {
    path: "/iof",
    component: <IOF_Prioritization />,
    exact: true,
    moduleName: "SNO",
  },
  {
    path: "/erm",
    component: <Exception_Reason_Managment />,
    exact: true,
    moduleName: "SNO",
  },
];

export default routes;
